/**
 * O conteúdo das orientações para o jurídico (E158.F3, GUS-191; ADR-0108 §2.6), o mesmo no portal
 * e na minuta da equipe: o aviso de uso interno, o caso e a versão, a conclusão do laudo do mesmo
 * snapshot e as providências em ordem — ou o alcance examinado, quando a busca conferida não achou
 * risco (CA10).
 */
import { ptBR } from '@/i18n/pt-BR';
import type { OrientacoesReservadasData } from '@/lib/orientacoes';

import { RiscoDaOrientacao } from './RiscoDaOrientacao';

const t = ptBR.orientacoes;

export function AvisoDeUsoInterno() {
  return (
    <div
      role="note"
      className="border border-warning-500 bg-warning-50 p-sc-4"
      data-testid="orientacoes-aviso"
    >
      <p className="text-body-sm font-semibold text-fg">{t.avisoTitulo}</p>
      <p className="mt-1 text-caption font-semibold text-warning-700">{t.aviso}</p>
      <p className="mt-1 text-caption text-fg">{t.avisoTexto}</p>
    </div>
  );
}

function identificacao(o: OrientacoesReservadasData): string {
  const c = o.cadastro;
  return [c.display_code, c.contrato, t.rodada.replace('{rodada}', String(o.rodada))]
    .filter((x): x is string => Boolean(x))
    .join(' · ');
}

/** E172.F5 (GUS-230 C3): o estado de trabalho e o papel do assistente técnico, como no documento. */
function conclusao(o: OrientacoesReservadasData): string {
  const c = o.conclusao;
  const pendente = c.proposta;
  const estagio = !pendente
    ? t.estagio.definida
    : c.chave === 'pendente'
      ? t.estagio.semProposta
      : t.estagio.proposta.replace('{rotulo}', c.rotulo);
  return t.conclusao
    .replace('{estado}', pendente ? t.pendente : c.rotulo)
    .replace('{modo}', t.modo[c.modo])
    .replace('{estagio}', estagio);
}

export function OrientacoesReservadas({ orientacoes }: { orientacoes: OrientacoesReservadasData }) {
  const o = orientacoes;
  return (
    <div className="space-y-sc-4" data-testid="orientacoes" data-situacao={o.situacao}>
      <p className="text-caption text-fg-muted" data-testid="orientacoes-identificacao">
        {identificacao(o)}
      </p>
      <AvisoDeUsoInterno />
      <p className="text-body-sm text-fg" data-testid="orientacoes-conclusao">
        {conclusao(o)}
      </p>
      <section className="border border-border bg-surface p-sc-4" aria-labelledby="o-que-fazer">
        <h2
          id="o-que-fazer"
          className="text-body-md font-semibold uppercase tracking-[0.1em] text-fg"
        >
          {t.oQueFazer}
        </h2>
        <p className="mt-1 max-w-prose text-caption text-fg-muted">{t.oQueFazerTexto}</p>
        {o.riscos.length === 0 ? (
          <p className="mt-sc-4 text-body-sm text-fg" data-testid="orientacoes-sem-riscos">
            {t.semRiscos.replace('{cobertura}', o.cobertura.replace(/\.$/, ''))}
          </p>
        ) : (
          <div className="mt-sc-2">
            {o.riscos.map((r) => (
              <RiscoDaOrientacao key={r.id} risco={r} />
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
